export default function (time) {
  const date = new Date(time * 1000);
  
  return date.toLocaleDateString()+" "+date.getHours()+":"+date.getMinutes()+":"+date.getSeconds();
}



// WEBPACK FOOTER //
// ./src/filters/date.js